var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconBedrooms = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.045 3.3v11.2",
  stroke: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M.955.5v14M.955 7.033h19.09M.955 7.033v-2.8h3.404a2.8 2.8 0 0 1 2.8 2.8M.955 10.766h19.09",
  stroke: "currentColor",
  strokeLinejoin: "round"
})));

export default SvgIconBedrooms;